import { z } from 'zod';
import { BUSINESS_CONFIG, getServiceTypeLabel } from './constants';

export const MAX_PROFILE_SERVICES = 10;
export const MAX_CUSTOM_SERVICE_LENGTH = 30;

export function normalizeService(value: string): string {
  const trimmed = value.trim();
  const option = BUSINESS_CONFIG.SERVICE_TYPE_OPTIONS.find(
    option =>
      option.label.toLowerCase() === trimmed.toLowerCase() ||
      option.value.toLowerCase() === trimmed.toLowerCase()
  );
  return option?.value ?? trimmed;
}

export const profileServicesSchema = z
  .array(
    z
      .string()
      .transform(normalizeService)
      .pipe(
        z
          .string()
          .min(1, 'Enter a service name')
          .max(MAX_CUSTOM_SERVICE_LENGTH, 'Use 30 characters or fewer')
      )
  )
  .max(MAX_PROFILE_SERVICES, 'Choose up to 10 services')
  .refine(
    services =>
      new Set(services.map(service => getServiceTypeLabel(service).toLowerCase())).size ===
      services.length,
    'Each service can only be added once'
  );
